export default "__VITE_ASSET__1af8a22b__"